import { AxiosResponse } from 'axios'
import { Moment } from 'moment'

import ClientSDK from '../../../App/ClientSDK'
import { IAppointmentsReport } from '../interface/IAppointmentsReport'
import { IAPIAppointmentsReport } from './interface/IAPIAppointmentsReport'
import { appointmentsReportTransformer } from './transformer/appointmentsReportTransformer'
import { formatForTimeline } from './transformer/utils/formatForTimeline'
import { TGroupBy } from './types/TGroupBy'

type TReportResponse = IAppointmentsReport[] | null

export class Client {
    static getAppointmentsReport = (
        from: Moment,
        to: Moment,
        groupBy: TGroupBy
    ): Promise<TReportResponse> => {
        const startDate: string = from.clone().format('YYYY-MM-DD')
        const endDate: string = to.clone().format('YYYY-MM-DD')
        const timelineFormat = formatForTimeline(groupBy)

        return ClientSDK.instance()
            .get(
                `reports/appointments/${startDate}/${endDate}/${timelineFormat}`
            )
            .then(
                (
                    response: AxiosResponse<IAPIAppointmentsReport[]>
                ): TReportResponse =>
                    appointmentsReportTransformer(response.data, groupBy)
            )
    }
}
